import { Module } from 'vuex'
import { RootState } from 'surface/xstore/types'

enum ContentPickerSource {
  FileBrowser = 'fileBrowser',
  LinkInput = 'linkInput',
  WebBrowser = 'webBrowser',
  PhotoBooth = 'photoBooth',
  VideoRecorder = 'videoRecorder',
  AudioRecorder = 'audioRecorder',
  DrawingCanvas = 'drawingCanvas',
  PadletBrowser = 'padletBrowser',
  MapBrowser = 'mapBrowser',
  ScreenshareRecorder = 'screenshareRecorder',
}

interface ContentSourceMenuPosition {
  top: number
  left: number
}

interface ContentPickerState {
  activeContentSource: ContentPickerSource | null
  contentSourceMenuPosition: ContentSourceMenuPosition | null
}

const ContentPickerModule: Module<ContentPickerState, RootState> = {
  namespaced: true,
  state: {
    activeContentSource: null,
    contentSourceMenuPosition: null,
  },
  getters: {
    xContentPickerPanel: (state): boolean => !!state.activeContentSource,
    activeContentPickerPanel: (state): ContentPickerSource | null => state.activeContentSource,
    xContentSourceMenu: (state): boolean => !!state.contentSourceMenuPosition,
    contentSourceMenuPosition: (state): ContentSourceMenuPosition | null => state.contentSourceMenuPosition,
  },
  mutations: {
    SHOW_CONTENT_SOURCE_MENU (state, position: ContentSourceMenuPosition): void {
      state.contentSourceMenuPosition = position
    },
    HIDE_CONTENT_SOURCE_MENU (state): void {
      state.contentSourceMenuPosition = null
    },
    PICK_CONTENT_SOURCE (state, source: ContentPickerSource): void {
      state.activeContentSource = source
    },
    HIDE_CONTENT_PICKER_PANEL (state): void {
      state.activeContentSource = null
    },
  },
  actions: {
    showContentSourceMenu ({ commit }, { position }): void {
      commit('SHOW_CONTENT_SOURCE_MENU', position)
    },
    hideContentSourceMenu ({ commit }): void {
      commit('HIDE_CONTENT_SOURCE_MENU')
    },
    pickContentSource ({ commit }, { source }): void {
      commit('PICK_CONTENT_SOURCE', source)
      commit('HIDE_CONTENT_SOURCE_MENU')
    },
    hideContentPickerPanel ({ commit }): void {
      commit('HIDE_CONTENT_PICKER_PANEL')
    },
  },
}

export default ContentPickerModule
export {
  ContentPickerState,
  ContentPickerSource,
}
